// firebase
import db from "@/firebase/init";
import firebase from "firebase";

const store = {
    initialProfile: {
        id: null,
        data: {
            age: null,
            allergies: [],
            androidHealth: null,
            appleHealth: null,
            bf: null,
            dishesDone: [],
            email: null,
            gender: null,
            goal: null,
            height: null,
            lastActive: null,
            level: null,
            likes: [],
            meals: [],
            milestoneFirstMeal: false,
            milestoneFirstShare: false,
            milestoneHealthConnected: false,
            milestoneInviteFriend: false,
            milestoneFirstSurvey: false,
            milestoneLostWeight: false,
            milestoneLostFat: false,
            milestoneBreakfastWeek: false,
            milestoneLunchWeek: false,
            milestoneDinnerWeek: false,
            milestonePerfectDay: false,
            milestonePerfectWeek: false,
            milestonePerfect20Days: false,
            milestonePerfectMonth: false,
            name: null,
            phone: null,
            picture: null,
            platform: null,
            points: 0,
            preferences: [],
            provider: null,
            restrictions: [],
            reviewed: null,
            role: null,
            sportsFrequency: null,
            sportsTime: null,
            sportsIntensity: null,
            subscriptionStatus: false,
            subscriptionPlan: null,
            subscriptionDate: null,
            target: {
                calcium: null,
                carbs: null,
                cholesterol: null,
                fat: null,
                fibers: null,
                iron: null,
                kcal: null,
                protein: null,
                saturatedFat: null,
                sodium: null,
                sugar: null,
                vitA: null,
                vitC: null
            },
            userId: null,
            weight: null
        }
    },
    initialFilters: {
        meal: "all",
        restrictions: [],
        preferences: []
    },
    state: {
        user: null,
        profile: {
            id: null,
            data: {
                age: null,
                allergies: [],
                androidHealth: null,
                appleHealth: null,
                bf: null,
                dishesDone: [],
                dishesShared: [],
                email: null,
                gender: null,
                goal: null,
                height: null,
                lastActive: null,
                level: null,
                likes: [],
                meals: [],
                milestoneFirstMeal: false,
                milestoneFirstShare: false,
                milestoneHealthConnected: false,
                milestoneInviteFriend: false,
                milestoneFirstSurvey: false,
                milestoneLostWeight: false,
                milestoneLostFat: false,
                milestoneBreakfastWeek: false,
                milestoneLunchWeek: false,
                milestoneDinnerWeek: false,
                milestonePerfectDay: false,
                milestonePerfectWeek: false,
                milestonePerfect20Days: false,
                milestonePerfectMonth: false,
                name: null,
                phone: null,
                picture: null,
                platform: null,
                points: 0,
                preferences: [],
                provider: null,
                restrictions: [],
                reviewed: null,
                role: null,
                sportsFrequency: null,
                sportsTime: null,
                sportsIntensity: null,
                subscriptionStatus: false,
                subscriptionPlan: null,
                subscriptionDate: null,
                target: {
                    calcium: null,
                    carbs: null,
                    cholesterol: null,
                    fat: null,
                    fibers: null,
                    iron: null,
                    kcal: null,
                    protein: null,
                    saturatedFat: null,
                    sodium: null,
                    sugar: null,
                    vitA: null,
                    vitC: null
                },
                userId: null,
                weight: null
            }
        },
        filters: {
            meal: "all",
            restrictions: [],
            preferences: []
        },
        mealplans: []
    },
    signoutUser() {
        this.state.user = null;
        this.state.profile = this.initialProfile
        this.state.filters = this.initialFilters;
        this.state.mealplans = [];
    },
    async signinUser() {
        this.state.user = firebase.auth().currentUser;
        if (this.state.user) {
            let profile = this.initialProfile;
            const ref = db.collection("users").where("userId", "==", this.state.user.uid);
            const snapshot = await ref.get();
            snapshot.forEach(doc => {
                const id = doc.id;
                const data = doc.data();
                profile = {
                    id: id,
                    data: data
                };
            });
            this.state.profile = profile;
        }
    },
    updateProfile(profile) {
        this.state.profile = profile;
    },
    addMealplan(mealsObj) {
        this.state.mealplans.push(mealsObj);
    }
}

export default store;